export const countries = [
  'United States',
  'Afghanistan',
  'American Samoa',
  'Barbados',
  'Bermuda',
  'Botswana',
  'Cambodia',
  'Congo, the Democratic Republic',
  'Cuba',
  'Ghana',
  'Guam',
  'Guinea Bissau',
  'Haiti',
  'Iran, Islamic Republic of',
  'Iraq',
  'Jamaica',
  'Lebanon',
  'Libya',
  'Mauritius',
  'Morocco',
  'Myanmar',
  'Nicaragua',
  'North Korea',
  'Pakistan',
  'Panama',
  'Puerto Rico',
  'Somalia',
  'South Sudan',
  'Syria',
  'The Bahamas',
  'United States Virgin Islands',
  'Venezuela',
  'Western Sahara',
  'Yemen',
  'Zimbabwe',
]
